import React from 'react';
import { CheckCircle, Calendar } from 'lucide-react';

interface ServiceCardProps {
  title: string;
  description: string;
  bullets?: string[];
  ctaHref?: string;
  icon: React.ReactNode;
  specialContent?: React.ReactNode;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  description,
  bullets,
  ctaHref = "/book",
  icon,
  specialContent
}) => {
  return (
    <div className="bg-white rounded-2xl p-6 lg:p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 h-full flex flex-col">
      {/* Icon and Title */}
      <div className="flex flex-col sm:flex-row sm:items-center mb-6">
        <div className="w-16 h-16 bg-accent-100 rounded-xl flex items-center justify-center text-accent-600 mb-4 sm:mb-0 sm:mr-4 flex-shrink-0">
          {icon}
        </div>
        <h2 className="text-xl lg:text-2xl font-heading font-bold text-gray-900 leading-tight">{title}</h2>
      </div>
      
      {/* Description */}
      <p className="text-gray-600 mb-6 leading-relaxed text-base flex-grow-0">{description}</p>
      
      {/* Special Content (like Rewind Technique explainer) */}
      {specialContent && (
        <div className="mb-6">
          {specialContent}
        </div>
      )}
      
      {/* Benefits/Bullets */}
      {bullets && bullets.length > 0 && (
        <div className="space-y-3 mb-8 flex-grow">
          {bullets.map((bullet, index) => (
            <div key={index} className="flex items-start space-x-3">
              <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span className="text-gray-700 text-base leading-relaxed">{bullet}</span>
            </div>
          ))}
        </div>
      )}
      
      {/* CTA Button */}
      <a
        href={ctaHref}
        {...(/^https?:\/\//.test(ctaHref) ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
        className="btn-primary text-center inline-flex items-center justify-center mt-auto py-3 px-6 text-base font-semibold"
      >
        <Calendar className="w-4 h-4 mr-2" />
        Book Your Free Consultation
      </a>
    </div>
  );
};

export default ServiceCard;
